var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function Footer(el) {

  var pintrk = window.pintrk;

  this.el = el;
  this.$el = $(el);

  this.bg = this.el.querySelector('.footer-bg');
  this.layers = this.el.querySelectorAll('[data-layer]');

  $(this.bg)
    .on('scroll-in.vsc-scroll', this.showLayers.bind(this))
    .on('scroll-reset.vsc-scroll', this.hideLayers.bind(this));

  var $input = this.$el.find('.ginput_container');
  var $submit = this.$el.find('.gform_footer');
  $input.append($submit);

  // Submit and open a new tab
  var openWindow = "http://vermontsmokeandcure.us11.list-manage1.com/subscribe?u=a29385323330d538d4f2148eb&id=48e15ef325";
  $('.newsletter .gform_footer').on('click', function(event) {
      event.preventDefault();
      var Email_Merge0 = $('.newsletter #MERGE0').val();
      var Email_WebSignup = $('.newsletter #WEBSIGNUP').val();
      window.open(openWindow + "&MERGE0=" + Email_Merge0 + "&WEBSIGNUP=" + Email_WebSignup, '_blank');
      pintrk('track', 'signup');
  });

  $(document).on('mailchimp-signedup', function() {
    $('.newsletter').find('.gforms_confirmation_message').css('display', 'block');
    $('.newsletter form').remove();
    if (typeof fbq !== 'undefined') {
      fbq('track', 'NewsletterSignup')
    }
  });

}

Footer.prototype.showLayers = function() {
  for(var i = 0; i < this.layers.length; i++) {
    var l = this.layers[i];

    TweenLite.fromTo(l, 1.3, {
      y: '100%',
      rotation: (Math.random() * 24) - 12
    }, {
      y: '0%',
      rotation: 0,
      delay: i * .15,
      ease: Back.easeOut
    });
  }
};

Footer.prototype.hideLayers = function() {
  TweenLite.killTweensOf('.footer-bg [data-layer]');

  for(var i = 0; i < this.layers.length; i++) {
    var l = this.layers[i];
    l.setAttribute('style', '');
  }
};

module.exports = Footer;